// const futuro = 1000000;
// const FV = futuro * -1;
// const anos = 10;
// const porcent = 3;
// const tx = porcent / 12;
// const PV = 500000;
// const gn = anos * 12;

// const dados = [gn, tx, PV, 0, FV];

let FIN_N = 0;
let FIN_I = 1;
let FIN_PV = 2;
let FIN_PMT = 3;
let FIN_FV = 4;
const begin = true;
let INTERPOLATION = 50;
let compoundf = 0;

function comppmtlim(i, n) {
  if (Math.abs(i) < 0.00000001) {
    return n;
  } else {
    return (1 - Math.pow(1 + i / 100, -n)) / (i / 100);
  }
}

function calcNPV(is_n, finmemory) {
  let n = finmemory[FIN_N];
  let i = finmemory[FIN_I];
  let pv = finmemory[FIN_PV];
  let pmt = finmemory[FIN_PMT];
  let fv = finmemory[FIN_FV];

  if (n == Math.floor(n) || is_n) {
    return (
      pv +
      (1 + (i / 100) * (begin ? 1 : 0)) * pmt * comppmtlim(i, n) +
      fv * Math.pow(1 + i / 100, -n)
    );
  } else if (!compoundf) {
    return (
      pv * (1 + (i / 100) * (n - Math.floor(n))) +
      (1 + (i / 100) * (begin ? 1 : 0)) * pmt * comppmtlim(i, Math.floor(n)) +
      fv * Math.pow(1 + i / 100, -Math.floor(n))
    );
  } else {
    return (
      pv * Math.pow(1 + i / 100, n - Math.floor(n)) +
      (1 + (i / 100) * (begin ? 1 : 0)) * pmt * comppmtlim(i, Math.floor(n)) +
      fv * Math.pow(1 + i / 100, -Math.floor(n))
    );
  }
}
function solve_infinity(val) {
  if (val > Math.pow(10, 95)) {
    val = Math.pow(10, 95);
  } else if (val < -Math.pow(10, 95)) {
    val = -Math.pow(10, 95);
  }
  return val;
}

function financecalc(dependent, finmemory) {
  let err = 0;

  if (dependent === 0) {
    err = err || finmemory[FIN_I] <= -100; // i <= -100
  } else if (dependent == 2) {
    err = err || finmemory[FIN_I] <= -100; // i <= -100
  } else if (dependent == 3) {
    err = err || finmemory[FIN_I] <= -100; // i <= -100
    err = err || finmemory[FIN_N] === 0; // n = 0
  } else if (dependent == 4) {
    err = err || finmemory[FIN_I] <= -100; // i <= -100
  }

  if (err) {
    return finmemory;
  }

  let firstNPV;
  let secondNPV;
  let interpolation_guess;
  let firstguess;
  let secondguess;
  let saved = finmemory[dependent];
  let iteration = INTERPOLATION;
  let threshold = 0.000000000125;
  let threshold_order = 0;

  // correct threshold so it is more "lax" when involved numbers are too big
  if (dependent != FIN_PV) {
    threshold_order += Math.abs(finmemory[FIN_PV]);
  }
  if (dependent != FIN_PMT) {
    threshold_order += Math.abs(finmemory[FIN_PMT]);
  }
  if (dependent != FIN_N && dependent != FIN_PMT) {
    threshold_order += Math.abs(finmemory[FIN_N] * finmemory[FIN_PMT]);
  }
  if (dependent != FIN_FV) {
    threshold_order += Math.abs(finmemory[FIN_FV]);
  }
  if (threshold_order > 0) {
    threshold *= threshold_order;
  }

  if (dependent == FIN_N || dependent == FIN_I || threshold_order <= 0) {
    secondguess = 1;
  } else {
    // initial guess for interpolation must be of same order as other parameters
    secondguess = threshold_order;
  }

  interpolation_guess = 0;

  while (--iteration >= 0) {
    firstguess = secondguess;
    secondguess = interpolation_guess;

    finmemory[dependent] = firstguess;

    if (finmemory[FIN_I] <= -100) {
      break;
    }

    firstNPV = calcNPV(dependent === 0, finmemory);

    finmemory[dependent] = secondguess;

    if (finmemory[FIN_I] <= -100) {
      break;
    }

    secondNPV = calcNPV(dependent === 0, finmemory);

    if (Math.abs(secondNPV) < threshold) {
      if (dependent === 0) {
        if (secondguess - Math.floor(secondguess) > 0.003) {
          finmemory[dependent] = Math.floor(finmemory[dependent]) + 1;
        } else {
          finmemory[dependent] = Math.floor(finmemory[dependent]);
        }
      }
      return finmemory;
    }

    let interpolation_B = (secondNPV - firstNPV) / (secondguess - firstguess); // B
    interpolation_guess = firstNPV - firstguess * interpolation_B; // A
    interpolation_guess /= -interpolation_B; // -A/B is the interpolation root
    interpolation_guess = solve_infinity(interpolation_guess);
  }

  // puts back the original value, since the calculated one may be NaN
  finmemory[dependent] = saved;

  return finmemory;
}


//const final = financecalc(3, dados);

// document.getElementById('result').innerHTML = final[3]
// document.getElementById('porcent').innerHTML = porcent

export default financecalc;


// WEBPACK FOOTER //
// ./src/helpers/calculadora.js